(function($) { 
    
    $.TrackerOSMOverlay = function() { 
        this._component_name = "osm_overlay";
    };

    $.Component.create($.TrackerOSMOverlay, {
        _init_: function(options) {
            this._options = options || {};
            this.osd = this.parent.parent;
            this.viewers = this.osd.viewers;

            this._show_osm_map = this._options.show_osm_map || false;
            this._osm_map_zoom = this._options.osm_map_zoom || 15;
            this._osm_tilesize = this._options.osm_tile_size || 256;
            this._canvas_overlay = null;

            // if(this.viewers.length > 0) {
            //     var viewer = this.viewers[0];
            //     viewer.addHandler('update-viewport', this._on_update_viewport_draw_osm.bind(this));
            // }
            this._osm_cache = {};

            this._on_btn_toggle_overlay = this._on_btn_toggle_overlay.bind(this);
            this.btnToggleOverlay = document.querySelector("button.btn-toggle-osm-overlay");
            if (this.btnToggleOverlay) {
                this.btnToggleOverlay.removeEventListener(ABDOUtil.getClickHandler(this.btnToggleOverlay), this._on_btn_toggle_overlay);
                ABDOUtil.setClickHandler(this.btnToggleOverlay, this._on_btn_toggle_overlay);
            }

            this._on_btn_create_overlay = this._on_btn_create_overlay.bind(this);
            this.btnCreateOSMOverlay = document.querySelector("button.btn-create-osm-overlay");
            if (this.btnCreateOSMOverlay) {
                this.btnCreateOSMOverlay.removeEventListener(ABDOUtil.getClickHandler(this.btnCreateOSMOverlay), this._on_btn_create_overlay);
                ABDOUtil.setClickHandler(this.btnCreateOSMOverlay, this._on_btn_create_overlay);
            }



        },

        destroy: function() {
            if (this.btnToggleOverlay) {
                this.btnToggleOverlay.removeEventListener(ABDOUtil.getClickHandler(this.btnToggleOverlay), this._on_btn_toggle_overlay); 
            }

            if (this.btnCreateOSMOverlay) {
                this.btnCreateOSMOverlay.removeEventListener(ABDOUtil.getClickHandler(this.btnCreateOSMOverlay), this._on_btn_create_overlay); 
            }
        },

        _on_btn_toggle_overlay: function() {
            if (this._canvas_overlay) { 
                var existing_overlay = this.viewers[0].getOverlayById(this._canvas_overlay.element.id);
                if (existing_overlay) {
                    this.viewers[0].removeOverlay(this._canvas_overlay.element.id);
                }
                else {
                    this.viewers[0].addOverlay(this._canvas_overlay);
                }
            }
             
        },

        _on_btn_create_overlay: function() {
            var yes = confirm("OpenStreetMapのオーバーレイの作成は時間がかかりますので、作成してもよろしいのでしょうか");
            if (yes) {
                this._draw_osm();
            }
        },

        // https://wiki.openstreetmap.org/wiki/Slippy_map_tilenames#ECMAScript_.28JavaScript.2FActionScript.2C_etc..29
        _lon2tile: function(lon,zoom) { return (lon+180)/360*Math.pow(2,zoom); },
        _lat2tile: function(lat,zoom)  { return (1-Math.log(Math.tan(lat*Math.PI/180) + 1/Math.cos(lat*Math.PI/180))/Math.PI)/2 *Math.pow(2,zoom); },
        _tile2lon: function(x,z) { return (x/Math.pow(2,z)*360-180); },
        _tile2lat: function(y,z) { var n=Math.PI-2*Math.PI*y/Math.pow(2,z); return (180/Math.PI*Math.atan(0.5*(Math.exp(n)-Math.exp(-n)))); },

        _preload_osm: function(onload, onerror) {
            var viewer = this.viewers[0];
            var localization = this.viewers[0].abdo.localization;

            var width = window.innerWidth;
            var height = window.innerHeight; 

            this.osd._show_ring();
            
            var initial_t = performance.now();
            var x,y;
            var processed_tiles = {};
            var processed_tiles_n = 0;
            var step = 2;
            var total_pixels = width * height / 2.0;
            var progress_at = Math.floor(total_pixels / 100);
            var processed = 0;
            var progress = 0;
            for (x = 0; x < width; x+=step) {
                for (y = 0; y < height; y+=step) {
                    var vp_coord = viewer.viewport.windowToViewportCoordinates(new OpenSeadragon.Point(x,y));
                    var lonlat = localization.vp2lonlat(vp_coord.x, vp_coord.y, true);
                    // var lonlat = null;
                    if (lonlat) {
                        var osm_coord = this._get_osm_coordinates(lonlat[1], lonlat[0], this._osm_map_zoom);
                        var tile_x = osm_coord.tile_coordinates.x;
                        var tile_y = osm_coord.tile_coordinates.y;
                        var tile_key = String(tile_x) + "_" + String(tile_y);
                        if (!(tile_key in processed_tiles)) { 
                            processed_tiles[tile_key] = { tile_x: tile_x, tile_y: tile_y, status: 0};
                            processed_tiles_n++;
                        }
                    }
                    else {
                        // console.log("coordinates not available");
                    }  
                    processed++;
                    if (processed % progress_at == 0) {
                        progress = (processed / total_pixels * 100).toFixed(2);
                        ABDOUtil.display_message("pixels processed: " + progress + "%"); 
                    }
                }
            }
            var final_t = performance.now();
            ABDOUtil.display_message("processed_tiles estimated in " + (final_t - initial_t) + " ms", 5000);

            initial_t = performance.now();
            var self = this;
            var processed_tiles_correct = 0;
            var progress; 
            for (var tile_key in processed_tiles) {
                var tile = processed_tiles[tile_key];
                this._get_osm_tile(tile.tile_x, tile.tile_y, this._osm_map_zoom, function(obj) { 
                    tile.status = 1;
                    processed_tiles_correct++;
                    if (processed_tiles_correct == processed_tiles_n) {
                        final_t = performance.now();
                        console.log("tiles loaded in " + (final_t - initial_t) + " ms");
                        this.osd._hide_ring();
                        if (onload) {
                            onload.call(self, processed_tiles);
                        }
                    }
                    else { 
                        ABDOUtil.display_message("processed tiles: " + (processed_tiles_correct / processed_tiles_n * 100).toFixed(2) + "%");
                    }
                }.bind(this),
                function(obj) {
                    tile.status = -1;
                    if (onerror) {
                        onerror.call(self, processed_tiles);
                    }
                    // console.log("Failed to load OSM tile: (" + tile.tile_x + "," + tile.tile_y + ")");
                    this.osd._hide_ring();
                }.bind(this));
            } 

            ABDOUtil.display_message("");
        },

        
        _draw_osm:  function(deformed) {
            if (typeof(deformed) !== 'boolean') {
                deformed = true;
            }

            this._preload_osm(this._draw_preloaded_osm.bind(this, deformed), function(processed_tiles){
                // alert("failed to preload required OSM tiles");
            });
        },

        _draw_preloaded_osm_deformed: function() {
            var viewer = this.viewers[0];
            var localization = viewer.abdo.localization;;
 
            var parent_canvas = this.osd.viewers[0].canvas.querySelector("canvas");
            var width = parent_canvas.width;
            var height = parent_canvas.height;

            var parent_bounds = this.osd.viewers[0].viewport.getBounds();

            var canvas_element = document.querySelector("canvas#osm_overlay");
            if (!canvas_element) {
                canvas_element = document.createElement("canvas");
                canvas_element.id = "osm_overlay"; 
                canvas_element.style.opacity = 1.0; 
                canvas_element.style.visibility = "visible";
                var opacity_delta = 0.05;
                var tracker = new OpenSeadragon.MouseTracker({
                    element: canvas_element,
                    dblClickHandler: function(evt) { 
                        this.osd.viewers[0].removeOverlay(canvas_element.id); 
                    }.bind(this),
                    scrollHandler: function(evt) {
                        if (evt.shift) {
                            var opacity = Number(canvas_element.style.opacity);
                            var new_opacity = opacity + opacity_delta*evt.scroll;

                            if (new_opacity > 1.0) {
                                new_opacity = 1.0;
                            }
                            else if  (new_opacity < 0.0) {
                                new_opacity = 0.0;
                            }

                            canvas_element.style.opacity = new_opacity;
                            evt.originalEvent.preventDefault();
                        }
                    },
                });
            }
            else {
                this.osd.viewers[0].removeOverlay(canvas_element.id);
            }

            canvas_element.width = width;
            canvas_element.height = height;
            var canvas_ctx = canvas_element.getContext("2d");
            var canvas_imgdata = canvas_ctx.getImageData(0, 0, width, height);
            var canvas_data = canvas_imgdata.data;
            
            // var buffer = document.createElement("canvas");
            // buffer.width = width;
            // buffer.height = height;
            // var buffer_data = buffer.getContext("2d").getImageData(0, 0, width, height);
            var total_pixels = width * height;
            var progress = 0;
            var processed = 0;
            var progress_at = Math.floor(total_pixels /100);
            if (progress_at == 0) {
                progress_at == 1;
            }

            var x,y;
            for (x = 0; x < width; x++) {
                for (y = 0; y < height; y++) {
                    var vp_coord = viewer.viewport.windowToViewportCoordinates(new OpenSeadragon.Point(x,y));
                    var lonlat = localization.vp2lonlat(vp_coord.x, vp_coord.y, true);
                    if (lonlat) {
                        var osm_coord = this._get_osm_coordinates(lonlat[1], lonlat[0], this._osm_map_zoom);
                        var tile_x = osm_coord.tile_coordinates.x;
                        var tile_y = osm_coord.tile_coordinates.y;

                        var tile_obj = this._get_osm_tile(tile_x, tile_y, this._osm_map_zoom, function(obj){
                            
                        });
                        if (tile_obj) {
                            // var tile_ctx = tile_obj.canvas.getContext("2d");
                            // var pixel_data = tile_ctx.getImageData(osm_coord.tile_pixels.x, osm_coord.tile_pixels.y, 1, 1); 
                            var pixel_data = tile_obj.tile_data;
                            // buffer.getContext("2d").putImageData(pixel_data, x, y);
                            var red_index = y * (width*4) + x*4;
                            var red_index_tile = osm_coord.tile_pixels.y * (this._osm_tilesize * 4) + osm_coord.tile_pixels.x*4;
                            var tile_r = pixel_data[red_index_tile];
                            var tile_g = pixel_data[red_index_tile+1];
                            var tile_b = pixel_data[red_index_tile+2];
                            canvas_data[red_index] = tile_r;
                            canvas_data[red_index+1] = tile_g;
                            canvas_data[red_index+2] = tile_b;
                            canvas_data[red_index+3] = 1000;
                        } 
                        else {
                            // console.error(tile_obj);
                        }
                    }
                    else { 
                        // set transparency
                        // buffer.getContext("2d").putImageData(pixel_data, x, y);
                        var red_index = y * (width*4) + x*4;
                        
                        // canvas_data[red_index] = 255;
                        // canvas_data[red_index+1] = 255;
                        // canvas_data[red_index+2] = 255;
                        // canvas_data[red_index+3] = 255;
 
                        canvas_data[red_index+3] = 120;
                        // console.error(lonlat);
                    }

                    processed++;
                    if (processed % progress_at == 0) {
                        progress = processed / total_pixels * 100;
                        ABDOUtil.display_message("pixels processed: " + progress.toFixed(2) + "%");
                    }

                }
                // console.log("column " + x + "/" + (width-1))
            }
            ABDOUtil.display_message("");

            // buffer.getContext("2d").putImageData(buffer_data, 0, 0);
            // canvas_ctx.drawImage(buffer, 0, 0);
            canvas_ctx.putImageData(canvas_imgdata, 0, 0); 

            this._canvas_overlay = {
                element: canvas_element,
                x: parent_bounds.x,
                y: parent_bounds.y,
                width: parent_bounds.width,
                height: parent_bounds.height 
            };
            this.osd.viewers[0].addOverlay(this._canvas_overlay);
            
        },

        _draw_preloaded_osm: function(deformed) {
            if (deformed) {
                this._draw_preloaded_osm_deformed();
                return;
            }

            var viewer = this.viewers[0];
            var localization = viewer.abdo.localization;

            var width = window.innerWidth;
            var height = window.innerHeight;

            var canvas_element = this.osd.viewers[0].canvas.querySelector("canvas");
            var canvas_ctx = canvas_element.getContext("2d");
            var canvas_imgdata = canvas_ctx.getImageData(0, 0, width, height);
            var canvas_data = canvas_imgdata.data;
            
            // get topleft and bottomright vp coordinates and their respective GPS coordinates
            var vp_coord_topleft = viewer.viewport.windowToViewportCoordinates(new OpenSeadragon.Point(0,0));
            var vp_coord_rightbottom = viewer.viewport.windowToViewportCoordinates(new OpenSeadragon.Point(width-1,height-1));
            var lonlat_topleft = localization.vp2lonlat(vp_coord_topleft.x, vp_coord_topleft.y, true);
            var lonlat_rightbottom = localization.vp2lonlat(vp_coord_rightbottom.x, vp_coord_rightbottom.y, true);
            var lonlat_diff = [lonlat_rightbottom[0] - lonlat_topleft[0], lonlat_rightbottom[1] - lonlat_topleft[1]];

            // paint interpolating linearly over those bounds restricted to the image pixels
            for (var x = 0; x < width; x++) {
                for (var y = 0; y < height; y++) {
                    var x_center = (x + 0.5) / width;
                    var y_center = (y + 0.5) / height;
                    var lonlat = [lonlat_topleft[0] + x_center*lonlat_diff[0], lonlat_topleft[1] + y_center*lonlat_diff[1]];  
                    var osm_coord = this._get_osm_coordinates(lonlat[1], lonlat[0], this._osm_map_zoom);
                    var tile_x = osm_coord.tile_coordinates.x;
                    var tile_y = osm_coord.tile_coordinates.y;

                    var tile_obj = this._get_osm_tile(tile_x, tile_y, this._osm_map_zoom, function(obj){
                        
                    });
                    if (tile_obj) {
                        // var tile_ctx = tile_obj.canvas.getContext("2d");
                        // var pixel_data = tile_ctx.getImageData(osm_coord.tile_pixels.x, osm_coord.tile_pixels.y, 1, 1); 
                        var pixel_data = tile_obj.tile_data;
                        // buffer.getContext("2d").putImageData(pixel_data, x, y);
                        var red_index = y * (width*4) + x*4;
                        var red_index_tile = osm_coord.tile_pixels.y * (this._osm_tilesize * 4) + osm_coord.tile_pixels.x*4;
                        var tile_r = pixel_data[red_index_tile];
                        var tile_g = pixel_data[red_index_tile+1];
                        var tile_b = pixel_data[red_index_tile+2];
                        canvas_data[red_index] = tile_r;
                        canvas_data[red_index+1] = tile_g;
                        canvas_data[red_index+2] = tile_b;
                        canvas_data[red_index+3] = 255;
                    } 
                    else {
                        // console.error(tile_obj);
                    } 
                }
                console.log("column " + x + "/" + (width-1))
            }

            // buffer.getContext("2d").putImageData(buffer_data, 0, 0);
            // canvas_ctx.drawImage(buffer, 0, 0);
            canvas_ctx.putImageData(canvas_imgdata, 0, 0); 
        },

        // _on_update_viewport_draw_osm: function(evt) {
        //     if (this._show_osm_map) {
        //         // this._draw_osm();
        //     }
        // },

        _get_osm_coordinates: function(lat, lon, zoom) { 
            var tile_point = new OpenSeadragon.Point(this._lon2tile(lon, zoom), this._lat2tile(lat, zoom));
            var tile_coordinates = { x: Math.floor(tile_point.x), y: Math.floor(tile_point.y) };

            var tile_pixels = {
                x: Math.floor( (tile_point.x - tile_coordinates.x)*this._osm_tilesize), 
                y: Math.floor( (tile_point.y - tile_coordinates.y)*this._osm_tilesize)};

            return { tile_point: tile_point, tile_coordinates: tile_coordinates, tile_pixels: tile_pixels };
        },

        _get_osm_tile: function(tile_x, tile_y, zoom, onload_callback, onerror_callback) { 

            var cache_key = String(zoom) + "/" + String(tile_x) + "/" + String(tile_y);

            if (cache_key in this._osm_cache && this._osm_cache[cache_key].status === "loaded") {
                if (! ("tile_data" in this._osm_cache[cache_key])) {
                    var canvas = document.createElement("canvas");
                    canvas.width = this._osm_tilesize;
                    canvas.height = this._osm_tilesize;
                    var ctx = canvas.getContext("2d"); 
                    ctx.drawImage(this._osm_cache[cache_key].image, 0, 0, this._osm_tilesize, this._osm_tilesize);

                    this._osm_cache[cache_key].canvas = canvas;
                    this._osm_cache[cache_key].tile_data = ctx.getImageData(0,0,this._osm_tilesize, this._osm_tilesize).data;
                }

                // this._emit("osm_tile_loaded_" + cache_key, this._osm_cache[cache_key]);
                if (onload_callback) {
                    onload_callback(this._osm_cache[cache_key]);
                }

                return this._osm_cache[cache_key];
            }
            else {
                // console.log("waiting_for_cache");
                if (onload_callback) {
                    this._once("osm_tile_loaded_" + cache_key, onload_callback);
                }
                if (onerror_callback) {
                    this._once("osm_tile_error_" + cache_key, onerror_callback);
                }
                var self = this;
                // var img = new Image(this._osm_tilesize, this._osm_tilesize);
                var img = new Image(this._osm_tilesize, this._osm_tilesize);
                img.crossOrigin = "Anonymous";
                var cache_obj = { image: img, status: "loading" };
                this._osm_cache[cache_key] = cache_obj;
                img.onload = function(evt) {  
                    var cache_obj = { image: img, zoom: zoom, x: tile_x, y: tile_y, status: "loaded"};
                    self._osm_cache[cache_key] = cache_obj;
                    img.remove();
                    self._emit("osm_tile_loaded_" + cache_key, cache_obj);
                };
                img.onerror = function(evt) {
                    var cache_obj = { image: img, zoom: zoom, x: tile_x, y: tile_y, status: "error"};
                    self._osm_cache[cache_key] = cache_obj;
                    img.remove();
                    self._emit("osm_tile_error_" + cache_key, cache_obj);
                };
                
                img.src = "https://a.tile.openstreetmap.org/" + String(zoom) + "/" + String(tile_x) + "/" + String(tile_y) + ".png"

                img.style.position = "fixed";
                img.style.top = "0";
                img.style.left = "0";
                img.style.display = "none";
                document.body.appendChild(img);
                return null;
            }
        },

    }, $.Tracker); 
})(ABDOMap);